var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import PreviewNorth from "./previewNorth";
import PreviewWest from "./previewWest";
import PreviewSouth from "./previewSouth";
import PreviewEast from "./previewEast";
import Main from "../main";
/**
 *
 * Composant previous
 */
export default function Previews() {
    return (_jsxs("div", __assign({ className: "relative flex flex-row flex-auto overflow-hidden" }, { children: [_jsx(PreviewWest, {}), _jsxs("div", __assign({ className: "flex flex-col flex-auto relative overflow-hidden transition-[filter] duration-[0.4s]" }, { children: [_jsx(PreviewNorth, {}), _jsx(Main, {}), _jsx(PreviewSouth, {})] })), _jsx(PreviewEast, {})] })));
}
